module.exports = __webpack_public_path__ + "static/media/yellowChart.67b9ce4d.png";